/* eslint-disable react-hooks/exhaustive-deps */
import { RegisterByGroupSchema } from "pages/ManagementAssets/Register/types"
import { convertNumber } from "utils"

export function RegisterByGroupFoother({ data }: { data: RegisterByGroupSchema[] }) {
  const totalAcquisition = data.reduce((total, item) => total + (Number(item?.acquisition_cost) || 0), 0);
  const totalNetbook = data.reduce((total, item) => total + (Number(item?.net_book) || 0), 0);

  return (
    <div className="label-text font-bold flex justify-end text-right mt-3">
      <div>
        <div>TOTAL ASSET ACQUISITION</div>
        <div>TOTAL ASSET NET BOOK VALUE</div>
      </div>
      <div className="mx-2">
        <div>:</div>
        <div>:</div>
      </div>
      <div>
        <div>{totalAcquisition ? convertNumber(totalAcquisition)?.intoCurrency : "0"}</div>
        <div>{totalNetbook ? convertNumber(totalNetbook)?.intoCurrency : "0"}</div>
      </div>
    </div>
  )
}